// extracted by mini-css-extract-plugin
export default {"wrapper":"Io-z","reviewFormSuccess":"Jo-z","header":"Ko-z","message":"Lo-z","paragraph":"Mo-z","lottieContainer":"No-z"};